import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { AlertController, PopoverController, ActionSheetController, LoadingController, Platform, NavController, ModalController } from '@ionic/angular';
import { InsuranceProviderValidationModel, InsuranceParamModel } from 'app/models/dms/insuranceProviderValidation.model';
import { ProductQuoteModel } from 'app/models/dms/productQuote.model';
import { SaleDetails_Vehicle, SaleDetailsModel } from 'app/models/dms/saleDetails.model';
import { GeneralService } from 'app/services/general.service';
import { SaleService } from 'app/services/sale.service';
import { StorageService } from 'app/services/storage.service';
import { UserService } from 'app/services/user.service';
import { Constants } from 'app/utility/constants';
import { ProductClass, MotorcentralEdition } from 'app/utility/enums';
import { timeout } from 'rxjs';
import { EditorPageComponent } from '../editor-page/editor-page.component';

@Component({
    selector: 'app-product-quote',
    templateUrl: './product-quote.component.html',
    styleUrls: ['./product-quote.component.scss'],
    standalone: false
})
export class ProductQuoteComponent extends EditorPageComponent implements OnInit
{
    @Input() insuranceProviderValidation: InsuranceProviderValidationModel;
    @Input() vehicle: SaleDetails_Vehicle;
    @Input() sale: SaleDetailsModel;
    @Input() quoteResult: ProductQuoteModel;

    insuranceParams: InsuranceParamModel[];

    showLoading: boolean = true;
    isExpress: boolean = false;

    constructor(
        public generalService: GeneralService, //for lookups - todo: remove
        public userService: UserService,
        public route: ActivatedRoute,
        public titleService: Title,
        public storage: StorageService,
        public alertController: AlertController,
        public popoverController: PopoverController,
        public actionSheetController: ActionSheetController,
        public loadingController: LoadingController,
        protected cd: ChangeDetectorRef,
        public platform: Platform,
        public navCtrl: NavController,
        public modalController: ModalController,
        private saleService: SaleService
    )
    {
        super(userService, route, titleService, storage, alertController, popoverController, actionSheetController, loadingController, cd, platform);
        this.editActive = true;
    }
    
    mcOnInit()
    {
        this.insuranceParams = this.insuranceProviderValidation.insuranceParams;
        this.isDirty = true;
        this.activeSegment = 'general';
        this.setupTitle();
        this.userService.getLicence()
            .subscribe({
                next: async license =>
                {
                    this.isExpress = (license.motorcentralEdition == MotorcentralEdition.Express);
                },
                error: err =>
                {
                    this.handleError(err);
                }
            });
    }

    mcViewDidEnter()
    {
        this.activeSegment = "general";
    }

    public getHeadingTitle(): string
    {
        if (this.insuranceProviderValidation && this.insuranceProviderValidation.selectedInsuranceProvider)
        {
            return this.insuranceProviderValidation.selectedInsuranceProvider.caption;
        }
        else
        {
            return "Insurance";
        }
    }

    public getPageName(): string
    {
        return "Insurance";
    }


    mcOnDestroy()
    {

    }

    public fetchTemplate()
    {

    }

    editLaunched: boolean = false;
    public async fetchObject()
    {
        this.setEdit(true);
        this.skeleton = true;
        this.showLoading = true;
        this.quoteResult.originalMviFields = JSON.parse(JSON.stringify(this.quoteResult.mviFields));
        this.setupFieldGroups();
        
    }


    async submitQuestionnaire()
    {

        let paramPayload = this.insuranceProviderValidation;
        paramPayload.mviProductQuote = this.quoteResult;

        const loading = await this.loadingController.create({
            message: 'Submitting...',
            duration: 60000
        });
        await loading.present();

        this.saleService.submitMviParams(paramPayload)
            .subscribe({
                next: x =>
                {
                    loading.dismiss();
                    this.modalController.dismiss({
                        'result': {
                            save: true
                        }
                    });

                    
                },
                error: error =>
                {
                    loading.dismiss();
                    this.handleError(error);
                }
            });
    }


    public async setupFieldGroups(): Promise<void>
    {
        this.fieldGroupTabs = await this.saleService.setupProductQuoteFieldGroups(this.quoteResult, true);
        this.skeleton = false;
        this.showLoading = false;
    }



    public handleFieldChangedAdditional(ev: any): void
    {
        if (!(ev.detail)) return;

        switch (ev.detail.id)
        {
            case 'selectedProductId':
                this.quoteResult.mviQuote.selectedProductId = ev.detail.value;
                const selectedProduct = this.quoteResult.mviQuote.products.find(x => x.id == this.quoteResult.mviQuote.selectedProductId);
                this.quoteResult.mviQuote.selectedProduct = selectedProduct;
                this.quoteResult.mviFields.hasRoadsideAssistance = selectedProduct.roadsideAssistance?.value > 0 ? true : false;
                this.quoteResult.mviFields.hasWindscreenCover = selectedProduct.windscreenCover?.value > 0 ? true : false;
                this.quoteResult.mviFields.excludeDriversUnder25 = false;
                this.quoteResult.mviFields.allowNamedDriversOnly = false;
                this.quoteResult.mviFields.hasNoClaimsBonusProtection = selectedProduct.noClaimsBonusProtection?.value > 0 ? true : false;
                this.recalculateQuoteAmount();
                break;
            case 'hasRoadsideAssistance':
                this.quoteResult.mviFields.hasRoadsideAssistance = ev.detail.value;
                this.recalculateQuoteAmount();
                break;
            case 'hasWindscreenCover':
                this.quoteResult.mviFields.hasWindscreenCover = ev.detail.value;
                this.recalculateQuoteAmount();
                break;
            case 'excludeDriversUnder25':
                this.quoteResult.mviFields.excludeDriversUnder25 = ev.detail.value;
                this.recalculateQuoteAmount();
                break;
            case 'allowNamedDriversOnly':
                this.quoteResult.mviFields.allowNamedDriversOnly = ev.detail.value;
                this.recalculateQuoteAmount();
                break;
            case 'hasNoClaimsBonusProtection':
                this.quoteResult.mviFields.hasNoClaimsBonusProtection = ev.detail.value;
                this.recalculateQuoteAmount();
                break;
            case 'voluntaryAdditionalExcess':
                this.quoteResult.mviFields.voluntaryExcessAmount = ev.detail.value;
                this.recalculateQuoteAmount();
                break;
            case 'rentalCarExcess':
                this.quoteResult.mviFields.rentalCarExcessAmount = ev.detail.value;
                this.recalculateQuoteAmount();
                break;
            case 'paymentMethodId':
                this.quoteResult.mviFields.paymentMethodId = ev.detail.value;
                this.quoteResult.mviQuote.paymentMethodId = ev.detail.value;
                break;
            case 'isImmobilizerConfirmed':
                this.quoteResult.mviFields.isImmobilizerConfirmed = ev.detail.value;
                break;
        }
    }

    async recalculateQuoteAmount()
    {
        const loading = await this.loadingController.create({
            message: 'Calculating Quote...',
            duration: 60000
        });
        await loading.present();

        this.saleService.calculateQuoteAmount(this.quoteResult)
            .subscribe({
                next: async result =>
                {
                    loading.dismiss();
                    this.quoteResult.mviFields.quoteSaleAmount = result;
                    this.setupFieldGroups();
                },
                error: err =>
                {
                    loading.dismiss();
                    this.handleError(err);
                }
            });
    }

    async cancelModal()
	{
		// console.log('cancelModal', this.isDirty);
		if (this.isDirty)
		{
			//prompt user to save
			const alert = await this.alertController.create({
				header: "Unsaved Changes",
				message: "Some data has changed. Do you want to close without saving?",
				buttons: [
					{
						text: 'Cancel',
						role: 'cancel',
						cssClass: 'primary',
						handler: () =>
						{
							//do nothing
							return;
						}
					},
					{
						text: 'OK',
						cssClass: 'danger',
						handler: () =>
						{
							this.dismissTheModal(false);
						}
					}
				]
			});

			await alert.present();
		}
		else
		{
			this.dismissTheModal(false);
		}
	}

    async dismissTheModal(save: boolean)
	{
		// console.log('dismissTheModal', save);
		// Dismiss the top modal returning some data object
        if (save)
        {
            this.submitQuestionnaire();
        }
        else
        {
            this.modalController.dismiss({
                'result': {
                    save: false
                }
            });
        }
	}

    async doRefresh(ev: any)
	{
		setTimeout(() =>
		{
			this.fetchObject();
			ev.target.complete();
		}, 250);
	}

    getQuestionnaireParamsAsParamPayload(): InsuranceProviderValidationModel
    {
        var paramPayload = JSON.parse(JSON.stringify(this.insuranceProviderValidation)) as InsuranceProviderValidationModel;
        paramPayload.insuranceParams = [];
        
        console.log(this.insuranceParams);
        for (let fieldGroupTab of this.fieldGroupTabs)
        {
            for (let fieldGroup of fieldGroupTab.fieldGroups)
            {
                for (let field of fieldGroup.fields)
                {
                    //find the item in the param sets
                    let paramSet = this.insuranceParams.find(x => x.paramId == field.id);

                    paramSet.paramValue = field.value || null;

                    let existing = paramPayload.insuranceParams.find(x => x.paramId == paramSet.paramId);
                    if (!existing)
                    {
                        paramPayload.insuranceParams.push(paramSet);
                    }
                }
            }
        }

        return paramPayload;
    } 

    

}